<template>
  <div>
    <GlobalTable
      ref="GlobalTable"
      v-loading="loading"
      :columns="tableColumns"
      :data="this.seachDataList"
      :currentPage="page.pageNum"
      :total="page.total"
      @handleCurrentChange="handleCurrentChange"
    >
      <el-table-column label="使用订单类型" slot="configWay" align="center">
        <template slot-scope="{ row }">
          <span>{{
            row.configWay == "01" ? "仅到店回收" : "到店及上门回收"
          }}</span>
        </template>
      </el-table-column>
      <el-table-column label="执行门店" slot="storeCount" align="center">
        <template slot-scope="{ row }">
          <div
            style="text-decoration: underline; cursor: pointer; color: #0981ff"
            @click="seeStoreList(row)"
          >
            {{ row.storeCount || 0 }}
          </div>
        </template>
      </el-table-column>
      <el-table-column label="礼包内容" slot="giftCount" align="center">
        <template slot-scope="{ row }">
          <div
            style="text-decoration: underline; cursor: pointer; color: #0981ff"
            @click="seeBagList(row)"
          >
            {{ row.giftCount }}
          </div>
        </template>
      </el-table-column>
      <el-table-column label="是否启用" slot="isEnable" align="center">
        <template slot-scope="{ row }">
          <el-switch
            inactive-color="#bebebe"
            @change="handleSwitch(row)"
            v-model="row.isEnable"
          ></el-switch>
        </template>
      </el-table-column>
      <el-table-column width="250" label="操作" slot="operation" align="center">
        <template slot-scope="{ row }">
          <el-button size="mini" type="primary" :disabled="row.isEnable" round @click="editGif(row)"
            >编辑</el-button
          >
          <el-button size="mini" type="danger" :disabled="row.isEnable" round @click="delGif(row)"
            >删除</el-button
          >
        </template>
      </el-table-column>
    </GlobalTable>
    <el-dialog
      :title="tipTitle"
      :visible.sync="tipDialogVisible"
      :close-on-click-modal="false"
      width="400px"
      @closed="tipClosed"
    >
      <div style="font-size:16px;text-align:center;margin:20px 0">
        是否确认此操作？
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="tipDialogVisible = false"
          >取 消</el-button
        >
        <el-button
          size="small"
          type="primary"
          :loading="tipBtnLoading"
          @click="tipSureClick"
          >确 定</el-button
        >
      </span>
    </el-dialog>
    <el-dialog
      :visible.sync="bagListShow"
      title="查看礼包内容"
      :close-on-click-modal="false"
      width="600px"
    >
      <GlobalTable
        ref="GlobalTable"
        v-loading="bagListloading"
        :columns="bagListColumns"
        :data="bagList"
        :maxHeight="500"
        :isPagination="false"
      >
        <el-table-column label="赠品类型" slot="giftType" align="center">
          <template slot-scope="{ row }">
            <span>{{ row.giftType == "01" ? "换新补贴" : "回收赠礼" }}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="赠品价值/最高补贴"
          slot="giftPrice"
          align="center"
        >
          <template slot-scope="{ row }"> {{ row.giftPrice || 0 }}元 </template>
        </el-table-column>
        <el-table-column label="发放门槛" slot="giveType" align="center">
          <template slot-scope="{ row }">
            <span v-if="row.giveType == '02'">无门槛(可叠加)</span>
            <span v-if="row.giveType == '01'"
              >订单金额满{{ row.threshold }}元</span
            >
          </template>
        </el-table-column>
      </GlobalTable>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" type="primary" @click="bagListShow = false"
          >关 闭</el-button
        >
      </span>
    </el-dialog>
    <DialogTbale
      class="store-table"
      :loading="userStoreLoading"
      :show="storeListShow"
      title="执行门店列表"
      :columns="storeListColumns"
      :data="storeListData"
      :currentPage="pageDialog.pageNum"
      :total="pageDialog.total"
      :pageSize="pageDialog.pageSize"
      :width="1013"
      @onClose="storeListClose"
      @handleCurrentChange="handleCurrentChangeDialog"
    >
      <div style="display:flex">
        <el-form :inline="true" :model="userStoreform">
          <el-form-item label="门店名称:" label-width="72px">
            <el-input
              size="small"
              v-model="userStoreform.storeName"
              clearable
              placeholder="请输入门店名称"
              class="form_input"
            ></el-input>
          </el-form-item>
          <el-form-item label="门店标签:" label-width="80px">
            <el-select
              v-model="userStoreform.tagId"
              placeholder="请选择标签"
              size="small"
              filterable
              clearable
            >
              <el-option
                v-for="item in tagList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="区域/总监:" label-width="80px">
            <el-select
              v-model="userStoreform.inspectorId"
              placeholder="请选择区域"
              size="small"
              filterable
              clearable
            >
              <el-option
                v-for="item in inspectorAreaList"
                :key="item.staffId"
                :label="
                  item.areaName
                    ? `${item.staffName}-${item.areaName}`
                    : item.staffName
                "
                :value="item.staffId"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button
              type="primary"
              @click="handleCurrentChangeDialog(1)"
              size="mini"
              >查询</el-button
            >
          </el-form-item>
        </el-form>
      </div>
      <div class="flex flex-je" style="margin-bottom:20px;">
        <el-button
          icon="el-icon-plus"
          type="warning"
          @click="handleCurrentChangeDialog2(1)"
          size="mini"
          >新增门店</el-button
        >
      </div>
      <el-table-column label="门店名称" slot="storeName" align="center">
        <template slot-scope="{ row }">
          <el-tooltip effect="dark" :content="row.storeName" placement="top">
            <div class="store-name">
              {{ row.storeName }}
            </div>
          </el-tooltip>
        </template>
      </el-table-column>
      <el-table-column label="区域/总监" slot="areaName" align="center">
        <template slot-scope="{ row }">
          <span v-if="row.areaName && row.inspectorName"
            >{{ row.areaName }}-{{ row.inspectorName }}</span
          >
          <span v-if="row.areaName && !row.inspectorName">{{
            row.areaName
          }}</span>
          <span v-if="!row.areaName && row.inspectorName">{{
            row.inspectorName
          }}</span>
          <span v-if="!row.areaName && !row.inspectorName">--</span>
        </template>
      </el-table-column>
      <el-table-column label="门店标签" slot="tagList" align="center">
        <template slot-scope="{ row }">
          <div class="tag-list" v-if="row.tagList && row.tagList.length">
            <span
              class="tag-style"
              v-for="item in row.tagList"
              :key="item.id"
              >{{ item.tagName }}</span
            >
          </div>
          <div v-else>--</div>
        </template>
      </el-table-column>
      <el-table-column
        label="是否启用线上业务"
        slot="isOnlineEnable"
        align="center"
      >
        <template slot-scope="{ row }">
          <span>{{ row.isOnlineEnable ? "是" : "否" }}</span>
        </template>
      </el-table-column>
      <el-table-column label="支持回收方式" slot="recycleWay" align="center">
        <template slot-scope="{ row }">
          <span>{{
            row.recycleWay == "01" ? "仅到店回收" : "到店及上门回收"
          }}</span>
        </template>
      </el-table-column>
      <el-table-column label="操作" slot="operation" align="center">
        <template slot-scope="{ row }">
          <el-button size="mini" type="danger" round @click="delStore(row)"
            >删除</el-button
          >
        </template>
      </el-table-column>
      <div
        slot="tableFooter"
        class="flex flex-je"
        style="padding-bottom: 20px; box-sizing: border-box"
      >
        <el-button size="small" @click="storeListClose">关 闭</el-button>
      </div>
    </DialogTbale>
    <DialogTbale
      :show="selectStoreShow"
      :loading="selectStoreLoading"
      title="新增执行门店"
      :columns="selectStoreColumns"
      isSelection
      :data="selectStoreData"
      ref="multipleTable"
      :currentPage="pageDialog2.pageNum"
      :total="pageDialog2.total"
      :pageSize="pageDialog2.pageSize"
      :width="1050"
      @onClose="selectStoreDialogClosed"
      @handleCurrentChange="handleCurrentChangeDialog2"
      @handleSelect="handleSelect"
    >
      <div style="display:flex">
        <el-form :inline="true" :model="selectStoreform">
          <el-form-item label="门店名称:" label-width="72px">
            <el-input
              size="small"
              v-model="selectStoreform.storeName"
              placeholder="请输入门店名称"
              class="form_input"
              clearable
            ></el-input>
          </el-form-item>
          <el-form-item label="门店标签:" label-width="80px">
            <el-select
              v-model="selectStoreform.tagId"
              placeholder="请选择标签"
              size="small"
              filterable
              clearable
            >
              <el-option
                v-for="item in tagList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="区域/总监:" label-width="80px">
            <el-select
              v-model="selectStoreform.inspectorId"
              placeholder="请选择区域"
              size="small"
              filterable
              clearable
            >
              <el-option
                v-for="item in inspectorAreaList"
                :key="item.staffId"
                :label="
                  item.areaName
                    ? `${item.staffName}-${item.areaName}`
                    : item.staffName
                "
                :value="item.staffId"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button
              type="primary"
              @click="handleCurrentChangeDialog2(1)"
              size="mini"
              >查询</el-button
            >
          </el-form-item>
        </el-form>
      </div>
      <el-table-column label="门店名称" slot="storeName" align="center">
        <template slot-scope="{ row }">
          <el-tooltip effect="dark" :content="row.storeName" placement="top">
            <div class="store-name">
              {{ row.storeName }}
            </div>
          </el-tooltip>
        </template>
      </el-table-column>
      <el-table-column label="区域/总监" slot="areaName" align="center">
        <template slot-scope="{ row }">
          <span v-if="row.areaName && row.inspectorName"
            >{{ row.areaName }}-{{ row.inspectorName }}</span
          >
          <span v-if="row.areaName && !row.inspectorName">{{
            row.areaName
          }}</span>
          <span v-if="!row.areaName && row.inspectorName">{{
            row.inspectorName
          }}</span>
          <span v-if="!row.areaName && !row.inspectorName">--</span>
        </template>
      </el-table-column>
      <el-table-column label="门店标签" slot="tagList" align="center">
        <template slot-scope="{ row }">
          <div class="tag-list" v-if="row.tagList && row.tagList.length">
            <span
              class="tag-style"
              v-for="item in row.tagList"
              :key="item.id"
              >{{ item.tagName }}</span
            >
          </div>
          <div v-else>--</div>
        </template>
      </el-table-column>
      <el-table-column
        label="是否启用线上业务"
        slot="isOnlineEnable"
        align="center"
      >
        <template slot-scope="{ row }">
          <span>{{ row.isOnlineEnable ? "是" : "否" }}</span>
        </template>
      </el-table-column>
      <el-table-column label="支持回收方式" slot="recycleWay" align="center">
        <template slot-scope="{ row }">
          <span>{{
            row.recycleWay == "01" ? "仅到店回收" : "到店及上门回收"
          }}</span>
        </template>
      </el-table-column>
      <div
        slot="tableFooter"
        class="flex flex-je"
        style="padding-bottom: 20px; box-sizing: border-box"
      >
        <el-button size="small" @click="selectStoreDialogClosed"
          >取 消</el-button
        >
        <el-button
          size="small"
          type="primary"
          :loading="btnLoading"
          @click="sureSelect"
          >确定</el-button
        >
      </div>
    </DialogTbale>
  </div>
</template>

<script>
import _api from "@/utils/request";
import moment from "moment";

export default {
  data() {
    return {
      tableColumns: [
        { label: "礼包名称", prop: "giftPackName" },
        { slotName: "configWay" },
        { slotName: "storeCount" },
        { slotName: "giftCount" },
        { label: "创建时间", prop: "createTime" },
        { label: "截止可用时间", prop: "expireTime" },
        { slotName: "isEnable" },
        { slotName: "operation" },
      ],
      seachDataList: [],
      page: {
        pageNum: 1,
        pageSize: 10,
        total: 0,
      },
      pageDialog: {
        pageNum: 1,
        pageSize: 10,
        total: 0,
      },
      pageDialog2: {
        pageNum: 1,
        pageSize: 10,
        total: 0,
      },
      loading: false,
      btnLoading: false,
      tipBtnLoading: false,
      tipDialogVisible: false,
      tipTitle: "提示",
      tipType: "",
      bagListShow: false,
      bagListloading: false,
      bagListColumns: [
        { label: "赠品名称", prop: "giftName" },
        { slotName: "giftType" },
        { slotName: "giftPrice" },
        { slotName: "giveType" },
      ],
      bagList: [],
      tagList: [],
      inspectorAreaList: [],
      storeListShow: false,
      storeListColumns: [
        { slotName: "areaName" },
        { slotName: "storeName" },
        { slotName: "tagList" },
        { slotName: "isOnlineEnable" },
        { slotName: "recycleWay" },
        { slotName: "operation" },
      ],
      storeListData: [],
      userStoreLoading: false,
      userStoreform: {
        storeName: "",
        tagId: "",
        inspectorId: "",
      },
      selectStoreShow: false,
      selectStoreColumns: [
        { slotName: "areaName" },
        { slotName: "storeName" },
        { slotName: "tagList" },
        { slotName: "isOnlineEnable" },
        { slotName: "recycleWay" },
        { slotName: "operation" },
      ],
      selectStoreData: [],
      selectStoreLoading: false,
      selectStoreform: {
        storeName: "",
        tagId: "",
        inspectorId: "",
      },
      selectStoreList: [],
    };
  },
  created() {
    this.handleCurrentChange();
  },
  mounted() {},
  computed: {
    SeachParams() {
      return this.$store.state.tagsView.SeachParams;
    },
  },
  watch: {
    SeachParams(newVal) {
      console.log(newVal);
      this.handleCurrentChange(1);
    },
  },
  methods: {
    // 订单编号跳转详情
    handleClick(row) {
      let routeData = this.$router.resolve({
        path: "/RecallOrder/Details",
        query: { type: "edit", id: row.orderNo },
      });
      window.open(routeData.href, "_blank");
    },
    //   切换页
    handleCurrentChange(val) {
      if (val) {
        this.page.pageNum = val;
      }
      const baseRequest = {
        giftPackName: this.SeachParams.giftPackName,
        storeId: this.SeachParams.storeId,
        startTime: this.SeachParams.startTime || "",
        endTime: this.SeachParams.endTime || "",
        pageNum: this.page.pageNum,
        pageSize: this.page.pageSize,
      };
      this.loading = true;
      _api.getGiftPackPage(baseRequest).then((res) => {
        if (res.code === 1) {
          this.seachDataList = res.data.records;
          this.page.total = res.data.total;
          this.page.pageNum = res.data.current;
          this.loading = false;
        }
        if (typeof this.SeachParams.disuseLoding === 'function') {
          this.SeachParams.disuseLoding();
        }
      }).catch(() => {
        if (typeof this.SeachParams.disuseLoding === 'function') {
          this.SeachParams.disuseLoding();
        }
      });
    },
    // 执行门店点击
    seeStoreList(row) {
      this.storeListShow = true;
      this.rowObj = row;
      this.getNotPInspectorSelect();
      this.getStoreTagSelect();
      this.handleCurrentChangeDialog(1);
    },
    // 查看礼包
    seeBagList(row) {
      this.bagListShow = true;
      this.bagListloading = true;
      _api.getGiftList({ giftPackId: row.id }).then((res) => {
        if (res.code == 1) {
          this.bagList = res.data;
        }
        this.bagListloading = false;
      });
    },
    // 是否启用
    handleSwitch(row) {
      this.rowObj = row;
      this.tipType = "switch";
      this.tipTitle = row.isEnable ? "启用提示" : "禁用提示";
      this.tipDialogVisible = true;
    },
    editGif(row) {
      this.$router.push({
        path: "/OnlinreyService/addGiftBag",
        query: { id: row.id },
      });
    },
    // 删除礼包
    delGif(row) {
      this.rowObj = row;
      this.tipType = "delGift";
      this.tipTitle = "删除礼包提示";
      this.tipDialogVisible = true;
    },
    // 提示弹框操作关闭
    tipClosed() {
      this.handleCurrentChange();
    },
    // 确认提示弹框操作
    tipSureClick() {
      this.tipBtnLoading = true;
      if (this.tipType == "delGift") {
        const params = {
          giftPackId: this.rowObj.id,
        };
        _api
          .removeGiftPack(params)
          .then((res) => {
            if (res.code == 1) {
              this.$message.success(res.msg || "操作成功");
              this.tipDialogVisible = false;
            }
            this.tipBtnLoading = false;
          })
          .catch(() => {
            this.tipBtnLoading = false;
          });
      } else if (this.tipType == "switch") {
        const params = {
          giftPackId: this.rowObj.id,
          isEnable: this.rowObj.isEnable,
        };
        _api
          .updateEnable(params)
          .then((res) => {
            if (res.code == 1) {
              this.$message.success(res.msg || "操作成功");
              this.tipDialogVisible = false;
              if(this.rowObj.isEnable){
                this.page.pageNum = 1
              }
            }
            this.tipBtnLoading = false;
          })
          .catch(() => {
            this.tipBtnLoading = false;
          });
      } else if (this.tipType == "delStore") {
        const params = {
          giftPackId: this.rowObj.id,
          storeId: this.rowStoreObj.storeId,
        };
        _api
          .removeUseStore(params)
          .then((res) => {
            if (res.code == 1) {
              this.$message.success(res.msg || "操作成功");
              this.tipDialogVisible = false;
              this.handleCurrentChangeDialog();
            }
            this.tipBtnLoading = false;
          })
          .catch(() => {
            this.tipBtnLoading = false;
          });
      } else if (this.tipType == "addUserStore") {
        let storeIds = [];
        this.selectStoreList.forEach((item) => {
          storeIds.push(item.storeId);
        });
        this.storeListData.forEach((item) => {
          storeIds.push(item.storeId);
        });
        let params = {
          giftPackId: this.rowObj.id,
          storeIds,
        };
        this.tipBtnLoading = true;
        _api
          .saveUseStore(params)
          .then((res) => {
            if (res.code == 1) {
              this.$message.success(res.msg || "操作成功");
              this.selectStoreShow = false;
              this.tipDialogVisible = false;
              this.handleCurrentChangeDialog(1);
            }
            this.tipBtnLoading = false;
          })
          .catch(() => {
            this.tipBtnLoading = false;
          });
      }
    },
    // 执行门店列表弹框关闭
    storeListClose() {
      this.storeListShow = false;
      this.handleCurrentChange();
    },
    // 获取区域总监
    getNotPInspectorSelect() {
      _api.getNotPInspectorSelect({ scope: "00" }).then((res) => {
        this.inspectorAreaList = res.data;
      });
    },
    // 获取门店标签
    getStoreTagSelect() {
      _api.getStoreTagSelect().then((res) => {
        this.tagList = res.data;
      });
    },
    // 执行门店列表分页
    handleCurrentChangeDialog(val) {
      if (val) {
        this.pageDialog.pageNum = val;
      }
      let params = {
        giftPackId: this.rowObj.id,
        inspectorId: this.userStoreform.inspectorId,
        storeName: this.userStoreform.storeName,
        tagId: this.userStoreform.tagId,
        type: "02",
        pageNum: this.pageDialog.pageNum,
        pageSize: this.pageDialog.pageSize,
      };
      this.userStoreLoading = true;
      _api.getUseStore(params).then((res) => {
        if (res.code == 1) {
          this.storeListData = res.data.records;
          this.pageDialog.total = res.data.total;
          this.pageDialog.pageNum = res.data.current;
          this.userStoreLoading = false;
        }
      });
    },
    // 选择执行门店弹框关闭
    selectStoreDialogClosed() {
      this.selectStoreShow = false;
      this.selectStoreList = [];
    },
    // 选择执行门店列表分页
    handleCurrentChangeDialog2(val) {
      this.selectStoreShow = true;
      if (val) {
        this.pageDialog2.pageNum = val;
      }
      let params = {
        giftPackId: this.rowObj.id,
        inspectorId: this.selectStoreform.inspectorId,
        storeName: this.selectStoreform.storeName,
        tagId: this.selectStoreform.tagId,
        type: "01",
        pageNum: this.pageDialog2.pageNum,
        pageSize: this.pageDialog2.pageSize,
      };
      this.selectStoreLoading = true;
      _api.getUseStore(params).then((res) => {
        if (res.code == 1) {
          this.selectStoreData = res.data.records;
          this.pageDialog2.total = res.data.total;
          this.pageDialog2.pageNum = res.data.current;

          this.storageArr = JSON.parse(JSON.stringify(res.data.records));
          let _rows = [];
          this.selectStoreData.forEach((item) => {
            if (
              this.selectStoreList.some((ele) => ele.storeId == item.storeId)
            ) {
              _rows.push(item);
            }
            return item;
          });
          this.toggleSelection(_rows);
          this.selectStoreLoading = false;
        }
      });
    },
    // 执行门店选择
    handleSelect(e) {
      console.log(e);
      this.selectStoreList = this.selectStoreList.filter((item) => {
        return !this.selectStoreData.some((ee) => ee.storeId == item.storeId);
      });
      let jsonArr = e;
      let newJson = this.selectStoreList; //盛放去重后数据的新数组
      for (let item1 of jsonArr) {
        //循环json数组对象的内容
        let flag = true; //建立标记，判断数据是否重复，true为不重复
        for (let item2 of newJson) {
          //循环新数组的内容
          if (item1.storeId == item2.storeId) {
            //让json数组对象的内容与新数组的内容作比较，相同的话，改变标记为false
            flag = false;
          }
        }
        if (flag) {
          //判断是否重复
          newJson.push(item1); //不重复的放入新数组。  新数组的内容会继续进行上边的循环。
        }
      }
      this.selectStoreList = newJson;
    },
    // 回显显示效果
    toggleSelection(rows) {
      Promise.resolve().then(() => {
        if (rows && rows.length) {
          rows.forEach((row) => {
            this.$refs.multipleTable.setSelection(row);
          });
        } else {
          this.$refs.multipleTable.clearSelection();
        }
      });
    },
    // 删除执行门店
    delStore(row) {
      this.rowStoreObj = row;
      this.tipType = "delStore";
      this.tipTitle = "删除门店提示";
      this.tipDialogVisible = true;
    },
    // 确定选择
    sureSelect() {
      if(this.selectStoreList.length){
        this.tipType = "addUserStore";
        this.tipTitle = "添加门店提示";
        this.tipDialogVisible = true;
      }else{
        this.selectStoreDialogClosed()
      }
      
    },
  },
};
</script>

<style lang="scss" scoped>
.flex {
  display: flex;
  align-items: center;
}
.flex-jb {
  display: flex;
  justify-content: space-between;
}
.flex-as {
  display: flex;
  align-items: flex-start;
}
.flex-je {
  display: flex;
  justify-content: flex-end;
}
.add-form {
  /deep/.el-input-group__append {
    border: 1px solid #0981ff;
    background: #0981ff;
    color: #ffffff;
  }
  // /deep/.el-form-item {
  //   margin-bottom: 10px;
  // }
  /deep/.el-form-item__content .el-input-group {
    vertical-align: middle;
  }
}
/deep/ .form_input .el-input__inner {
  height: 30px !important;
}
.tag-list {
  display: flex;
  flex-flow: wrap;
}
.tag-style {
  min-width: 88px;
  padding: 0 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
  line-height: 12px;
  height: 26px;
  font-size: 12px;
  color: #0981ff;
  background: #ffffff;
  border: 1px solid #0981ff;
  border-radius: 13px;
  margin: 5px 0;
  margin-right: 5px;
}
.store-table {
  /deep/.el-form-item {
    margin-bottom: 10px !important;
  }
}
// 门店名称
.store-name {
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2; //控制行数
  overflow: hidden;
}
</style>
